import {
    RESERVATIONS_LIST_FILTER_UPDATE,
} from 'store/actions/types';

export const updateReservationFilter = (filters) => {
    return {
        type: RESERVATIONS_LIST_FILTER_UPDATE,
        payload: filters,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/reservations/updateReservations.js